import React from 'react';
import get from 'lodash/get';

import Select, { BooktypeOption, BooktypeValueContainer } from 'rebook/apps/base/components/Select';
import { FILTER_BY_BOOKTYPE } from 'rebook/apps/base/constants';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import popQueryString from 'rebook/apps/utils/urls/popQueryString';
import Button from 'rebook/apps/base/components/Button';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';

import styles from './style.scss';


class BaseUserBooksView extends React.Component {
  constructor(props) {
    super(props);

    this.pageLimit = 24;
    this.title = '';
    this.readingList = null;

    this.state = {
      pageNumber: 1,
      lastPageNumber: 0,
      books: null,
      type: 'all',
      allBooks: null,
      textBooks: null,
      audioBooks: null,
      header: {
        title: this.getInitialHeaderTitle(),
        bookCount: null,
        image: null,
        backLink: null,
      },
      isFetching: true,
      object: null,
    };
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      title: this.title,
    });
    const { userId } = this.props.match.params;
    this.setState({ userId }, () => this.fetchBookList(null, this.state.type));
  }

  componentWillReceiveProps(nextProps) {
    const newUserId = nextProps.match.params.userId;
    if (newUserId && newUserId !== this.state.userId) {
      const newState = {
        userId: newUserId,
      };
      this.setState({ ...this.defaultState, ...newState }, () => this.fetchBookList(null, this.state.type));
    }
  }

  getInitialHeaderTitle() {
    return 'Мои книги';
  }

  filterByBooktype(booktype) {
    this.setState({ type: booktype.type });

    if (booktype.value !== null) {
      let newQueryString = fixQueryString(
        get(this, 'props.location.search', ''), { type: booktype.value }
      );
      newQueryString = popQueryString(newQueryString, ['page']);
      this.props.history.push({
        search: newQueryString,
      });
    }
    else {
      this.props.history.push({
        search: popQueryString(get(this, 'props.location.search', ''), ['type']),
      });
    }
    this.fetchBookList(null, booktype.type);
  }

  getBooksFromState(type) {
    this.setState({
      header: {
        ...this.state.header,
        ...{ bookCount: get(this.state[type], 'bookCount') },
      },
      isFetching: false,
    });
  }

  fetchNextPage(next, type) {
    const bookType = [`${type}Books`];

    this.setState({ isFetching: true });

    fetchQuery(next, { apiVersion: 6 })
      .then(({ data }) => {
        this.setState({
          [bookType]: {
            books: this.state[bookType].books.concat(data.objects),
            next: data.meta.next,
            bookCount: this.state[bookType].bookCount,
          },
          isFetching: false,
        });
      });
  }

  fetchBookList(url, type) {
    const bookStateType = `${type}Books`;

    if (!url) {
      url = `/api/bookuserlist/?user=${this.state.userId}&limit=${this.pageLimit}`;

      if (this.readingList) {
        url += `&readinglist=${this.readingList}`;
      }

      if (type === 'audio' || type === 'text') {
        url += `&type=${type}`;
      }
    }

    if (get(this.state[bookStateType], 'books')) {
      this.getBooksFromState(bookStateType);
      return;
    }

    fetchQuery(url, { apiVersion: 6 })
      .then(({ data }) => {
        this.fetchBookCount(data.objects, type, bookStateType, data.meta.next);
      });
  }

  fetchBookCount(books, type, bookStateType, next) {
    const url = '/api/stat/bookuserlist/bystatus/';
    const { readingList: listType } = this;

    fetchQuery(url, { apiVersion: 6 })
      .then(({ data }) => {
        const textBookCountList = [null, data.text.wishlist, data.text.reading, data.text.read];
        const audioBookCountList = [null, data.audio.wishlist, data.audio.reading, data.audio.read];
        const textBookCount = listType
          ? textBookCountList[listType]
          : textBookCountList.reduce((sum, count) => sum + count);

        const audioBookCount = listType
          ? audioBookCountList[listType]
          : audioBookCountList.reduce((sum, count) => sum + count);

        const bookCount = type === 'text'
          ? textBookCount
          : type === 'audio'
            ? audioBookCount
            : textBookCount + audioBookCount;

        this.setState({
          header: { ...this.state.header, ...{ bookCount } },
          [bookStateType]: {
            bookCount,
            books,
            next,
          },
          isFetching: false,
        });
      });
  }

  render() {
    const { header, type, isFetching } = this.state;
    const books = get(this.state[`${type}Books`], 'books');
    const next = get(this.state[`${type}Books`], 'next');

    return (
      <div className="section">
        {this.breadcrumbs.length > 0 && <BreadCrumbs links={this.breadcrumbs} />}
        <CatalogHeader {...header} />
        <Select
          name="booktype"
          options={FILTER_BY_BOOKTYPE}
          components={{
            Option: BooktypeOption,
            ValueContainer: BooktypeValueContainer,
          }}
          defaultValue={FILTER_BY_BOOKTYPE.find((item) => (item.type == type))}
          width={176}
          onChange={(value) => this.filterByBooktype(value)} />
        {get(books, 'length') > 0 && <BookList books={books} shouldShowAvailable />}
        {get(books, 'length') === 0 && <EmptyFilterResult />}
        {get(books, 'length', null) === null && <BookList books={[...Array(5)]} />}
        {next && (
          <div className={styles.button}>
            <Button
              extraClassName="jest-userprofile-load-more"
              isDisabled={isFetching}
              handleClick={() => this.fetchNextPage(next, type)}
              theme="secondary">
              Показать еще
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default BaseUserBooksView;
